module.exports = __webpack_public_path__ + "img/IT.342ae3b7.svg";